import * as earlyGameboard from './earlyGameboard'

import * as h2Api from '../h2Api'

export const PROFILE_LOAD = 'PATHWAY_PROFILE_LOAD'
export const PROFILE_LOG = 'PATHWAY_PROFILE_LOG'
export const PROFILE_SELECT_LOADED = 'PROFILE_SELECT_LOADED'
export const RATE_PATHWAY = 'RATE_PATHWAY'
export const SAVE_RATE_PATHWAY = 'SAVE_RATE_PATHWAY'
export const UPDATE_PROFILE_CACHE = 'UPDATE_PATHWAY_PROFILE_CACHE'

export const saveRating = (pathway, ratingType) => (dispatch, getState) => {
  const loadedGameId = getState().early.gameboard.loadedGameId
  const name = getState().early.gameboard.userInfo

  return dispatch(
    h2Api.post(`/early/${loadedGameId}/rating`, {
      objectType: 'pathway',
      objectId: pathway.id,
      rating: ratingType
    })({ type: SAVE_RATE_PATHWAY })
  )
}

export const ratePathway = (pathway, ratingType) => dispatch => {
  console.log('RATING', pathway, ratingType)

  return Promise.resolve(
    dispatch({
      type: RATE_PATHWAY,
      pathway,
      rating: ratingType
    })
  )
}

export const cachePathway = pathway => dispatch => {
  dispatch({ type: UPDATE_PROFILE_CACHE, pathway })
}

export const randomizePathway = () => (dispatch, getState) => {
  const pwCache = getState().pathwayProfile.profileCache
  const keys = Object.keys(pwCache)
  const sortedKeys = [...keys].sort(() => {
    return 0.5 - Math.random()
  })

  //return dispatch(h2Api.get("/pathways/pathway/random")({type: PROFILE_LOAD}))
  return Promise.resolve(sortedKeys[0])
}

export const forceLoadPathway = pathwayId => (dispatch, getState) => {
  return dispatch(h2Api.get(`/pathways/${pathwayId}`)({ type: PROFILE_LOAD }))
}

export const loadPathway = pathwayId => (dispatch, getState) => {
  const exists = () => {
    dispatch({ type: PROFILE_SELECT_LOADED, selectedPathway: pathwayId })

    return dispatch(h2Api.post(`/pathways/${pathwayId}/log`)({ type: PROFILE_LOG }))
  }

  return exists().then(() => {
    dispatch({
      type: earlyGameboard.REGISTER_VIEW,
      activityKey: 'pathways',
      activityValue: {
        pathwayId,
        earlyExploration: true
      }
    })
  })
}
